<template>
  <div class="d-flex align-items-center">
    <template v-if="selected_report?.story_board">
      <div
        :class="[
          'd-none d-xl-flex',
          'btncontainer1',
          { active: activeButton === 'buttons1', 'show-buttons': showButtons1 }
        ]"
      >
        <div :class="['main-border d-flex align-items-center', { 'show-buttons': showButtons1 }]">
          <button
            :class="[
              'main-button',
              'hdd-btn',
              { active: !showButtons1 && story_board_menu.some(Boolean) }
            ]"
            @click="toggleButtons1('buttons1')"
          >
            웹 보고서 편집
          </button>
        </div>
        <div class="d-flex button-container">
          <div class="header-dropdown">
            <template v-if="showButtons1">
              <button
                v-for="(button, index) in storyboardButtons"
                :key="index"
                class="extra-button hdd-btn mx-1"
                :class="{ active: story_board_menu[index] }"
                @click="$router.push({ name: button.route })"
              >
                {{ button.label }}
              </button>
            </template>
          </div>
        </div>
      </div>

      <div class="mobile-dropdown d-block d-xl-none">
        <b-dropdown
          id="dropdown-1"
          text="웹 보고서 편집"
          no-caret
          class="hdd-btn p-0"
          :class="{ active: story_board_menu.some(Boolean) }"
          :variant="story_board_menu.some(Boolean) ? 'bottom-circle' : 'icon-gray2'"
        >
          <b-dropdown-item
            v-for="(button, index) in storyboardButtons"
            :key="index"
            class="extra-button hdd-btn"
            :class="{ active: story_board_menu[index] }"
            @click="$router.push({ name: button.route })"
          >
            {{ button.label }}
          </b-dropdown-item>
        </b-dropdown>
      </div>

      <div
        :class="[
          'd-none d-xl-flex',
          'btncontainer2',
          { active: activeButton === 'buttons2', 'show-buttons': showButtons2 }
        ]"
      >
        <div :class="['main-border  d-flex align-items-center', { 'show-buttons': showButtons2 }]">
          <button
            :class="[
              'main-button',
              'hdd-btn',
              { active: !showButtons2 && menu_active.some(Boolean) }
            ]"
            @click="toggleButtons2('buttons2')"
          >
            보고 표준 편집
          </button>
        </div>
        <div class="d-flex button-container">
          <div class="header-dropdown">
            <template v-if="showButtons2">
              <button
                v-for="(button, index) in standardButtons"
                :key="index"
                class="extra-button hdd-btn mx-1"
                :class="{ active: menu_active[index] }"
                @click="button.action"
              >
                {{ button.label }}
              </button>
            </template>
          </div>
        </div>
      </div>

      <div class="mobile-dropdown d-block d-xl-none">
        <b-dropdown
          id="dropdown-2"
          text="보고 표준 편집"
          no-caret
          class="hdd-btn p-0"
          :class="{ active: menu_active.some(Boolean) }"
          :variant="menu_active.some(Boolean) ? 'bottom-circle' : 'icon-gray2'"
        >
          <b-dropdown-item
            v-for="(button, index) in standardButtons"
            :key="index"
            class="extra-button hdd-btn"
            :class="{ active: menu_active[index] }"
            @click="button.action"
          >
            {{ button.label }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </template>

    <!-- 새 버튼 그룹 문서함 추가 -->
    <div
      :class="[
        'd-none d-xl-flex',
        'btncontainer3',
        { active: activeButton === 'buttons3', 'show-buttons': showButtons3 }
      ]"
    >
      <div :class="['main-border d-flex align-items-center', { 'show-buttons': showButtons3 }]">
        <button
          :class="[
            'main-button',
            'hdd-btn',
            { active: !showButtons3 && document_menu.some(Boolean) }
          ]"
          @click="toggleButtons3('buttons3')"
        >
          문서함
        </button>
      </div>
      <div class="d-flex button-container">
        <div class="header-dropdown" :class="{ '': activeButton != 'buttons3' }">
          <template v-if="showButtons3">
            <button
              v-for="(button, index) in documentButtons"
              :key="index"
              class="extra-button hdd-btn mx-1"
              :class="{ active: document_menu[index] }"
              @click="button.action"
            >
              {{ button.label }}
            </button>
          </template>
        </div>
      </div>
    </div>

    <!-- 모바일 문서함 드롭다운 -->
    <div class="mobile-dropdown d-block d-xl-none">
      <b-dropdown
        id="dropdown-3"
        text="문서함"
        no-caret
        class="hdd-btn p-0"
        :class="{ active: document_menu.some(Boolean) }"
        :variant="document_menu.some(Boolean) ? 'bottom-circle' : 'icon-gray2'"
      >
        <b-dropdown-item
          v-for="(button, index) in documentButtons"
          :key="index"
          class="extra-button hdd-btn"
          :class="{ active: document_menu[index] }"
          @click="button.action"
        >
          {{ button.label }}
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'HeaderDropdown',
  data() {
    return {
      activeButton: null,
      story_board_menu: [false, false, false, false],
      menu_active: [false, false, false, false],
      document_menu: [false, false, false, false]
    };
  },
  computed: {
    ...mapState('report_list', ['report_code', 'report_list', 'standard_mode']),
    ...mapGetters('report_list', ['selected_report']),
    ...mapState('headerDropdown', ['showButtons1', 'showButtons2', 'showButtons3']),
    storyboardButtons() {
      return [
        { label: '목차 구성', route: 'StoryBoardToCEdit' },
        { label: '보고서 작성', route: 'WriteStoryBoard' },
        { label: '메인페이지', route: 'StoryBoardSetting' }
      ];
    },
    standardButtons() {
      return [
        { label: '지표 선택', action: this.goIndicatorSelectorPage },
        { label: 'Index 작성', action: this.go_editor_page }
      ];
    },
    documentButtons() {
      return [
        { label: '데이터 테이블', action: () => this.$router.push('/mg_data_tables') },
        { label: '문서 및 링크', action: () => this.$router.push('/mg_documents') },
        { label: '비즈니스 사례', action: () => this.$router.push('/mg_business_cases') },
        { label: '차트', action: () => this.$router.push('/mg_charts') }
      ];
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        const default_menu_active = Array(3).fill(false);
        const default_story_board_menu = Array(4).fill(false);
        const default_document_menu = Array(4).fill(false);
        this.menu_active = default_menu_active;
        this.story_board_menu = default_story_board_menu;
        this.document_menu = default_document_menu;

        const storyBoardRoutes = {
          StoryBoardToCEdit: 0,
          WriteStoryBoard: 1,
          ReportCompare: 1,
          StoryBoardSetting: 2
        };

        if (storyBoardRoutes.hasOwnProperty(to.name)) {
          default_story_board_menu[storyBoardRoutes[to.name]] = true;
          this.story_board_menu = default_story_board_menu;
          if (to.name === 'StoryBoardTranslateSet') {
            this.set_standard_mode('STORY_BOARD');
          }
        }

        const mainPageRoutes = [
          'StoryBoardSetting',
          '/story_board_settings/component_settings',
          '/story_board_settings/footer_setting'
        ];

        if (mainPageRoutes.includes(to.path)) {
          default_story_board_menu[2] = true;
          this.story_board_menu = default_story_board_menu;
        }

        const indicatorRoutes = [
          '/get_gri_recommendations',
          '/get_sasb_recommendations',
          '/get_tcfd_recommendations',
          '/gri_indicators',
          '/sasb_indicators',
          '/tcfd_indicators',
          '/view_indicators_list',
          '/editDCToC'
        ];

        const mainRoutes = [
          'Gri100_2021',
          'Gri2',
          'Gri3',
          'Gri200',
          'Gri300',
          'Gri400',
          'WriteTcfd',
          'WriteSasb',
          'WriteDataCenters'
        ];

        const documentRoutes = {
          MgDataTables: 0,
          MgDocuments: 1,
          MgBusinessCases: 2,
          MgCharts: 3
        };

        if (
          to.name !== 'Main' &&
          ![
            '/payment_service',
            '/user_payment_check',
            '/product_pay',
            '/subscription_payment_method'
          ].includes(to.path)
        ) {
          if (indicatorRoutes.includes(to.path)) {
            default_menu_active[0] = true;
            this.menu_active = default_menu_active;
          }

          if (mainRoutes.includes(to.name)) {
            default_menu_active[1] = true;
            this.menu_active = default_menu_active;

            if (['WriteSasb', 'WriteTcfd', 'Gri2'].includes(to.name)) {
              const standardModeMap = {
                WriteSasb: 'SASB',
                WriteTcfd: 'TCFD',
                Gri2: 'GRI'
              };
              this.set_standard_mode(standardModeMap[to.name]);
            }
          }
        }
        if (documentRoutes.hasOwnProperty(to.name)) {
          default_document_menu[documentRoutes[to.name]] = true;
          this.document_menu = default_document_menu;
        } else {
          this.activeButton = null;
        }
      }
    }
  },
  methods: {
    ...mapMutations('report_list', ['set_standard_mode']),
    ...mapActions('report_indicators', ['readReportTopics', 'readReportIndicators']),
    ...mapActions('headerDropdown', ['toggleButtons1', 'toggleButtons2', 'toggleButtons3']),
    goIndicatorSelectorPage() {
      const first_type = Object.keys(this.selected_report.report_type)[0];
      const standardModes = {
        GRIv2021: { mode: 'GRI', route: 'GetGriRecommendations' },
        GRIv2016: { mode: 'GRI', route: 'GetGriRecommendations' },
        SASBv2023: { mode: 'SASB', route: 'GetSasbRecommendations' },
        TCFDv2021: { mode: 'TCFD', route: 'GetTcfdRecommendations' }
      };
      if (standardModes[first_type]) {
        this.set_standard_mode(standardModes[first_type].mode);
        this.pageGo({ name: standardModes[first_type].route });
      }
    },
    go_editor_page() {
      if (!this.selected_report) return;
      const first_type = Object.keys(this.selected_report.report_type)[0];
      const editorRoutes = {
        GRIv2021: 'Gri2',
        GRIv2016: 'Gri100',
        SASBv2023: '/write_report/sasb',
        TCFDv2021: '/write_report/tcfd'
      };
      if (editorRoutes[first_type]) {
        this.set_standard_mode(first_type.split('v')[0]);
        this.$router.push({ name: editorRoutes[first_type] });
      }
    },
    pageGo(to) {
      if (this.selected_report) {
        if (
          to.name === 'GetGriRecommendations' ||
          to.name === 'GetSasbRecommendations' ||
          to.name === 'GetTcfdRecommendations'
        ) {
          if (this.selected_report.state < 1) {
            this.$router.push(to);
          } else if (this.selected_report.state >= 1) {
            this.readReportTopics({ report_code: this.report_code });
            this.readReportIndicators({ report_code: this.report_code });

            if (this.standard_mode === 'GRI') this.$router.push({ name: 'SelectGriIndicators' });
            else if (this.standard_mode === 'SASB')
              this.$router.push({ name: 'SelectSasbIndicators' });
            else if (this.standard_mode === 'Tcfd')
              this.$router.push({ name: 'SelectTcfdIndicators' });
          } else {
            alert(`보고서 기본 정보를 입력하고 보고서를 생성해 주세요.`);
          }
        } else if (to.name == 'CheckReport') {
          if (this.selected_report.state >= 2) {
            this.$router.push(to);
          } else {
            alert(`보고 내용을 최소 1개 이상 작성 후 검토 및 검증 가능합니다.`);
          }
        } else if (to.name == 'BasicTranslateSet') {
          this.$router.push(to);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile-dropdown {
  z-index: 2;
}

.hdd-btn {
  border: 1px solid transparent;
  background-color: transparent;
  font-weight: 400;
  font-size: 1.05rem;
  padding: 0.25rem;
  color: #8a8a8a;
  position: relative;
  border-radius: 0.25rem;

  &:hover {
    background-color: rgba(0, 0, 0, 0.07);
    color: #6c6c6c;
  }
}

.hdd-btn.active {
  color: #212529;
  font-weight: 600;

  &::after {
    position: absolute;
    bottom: -2px;
    left: 5px;
    width: calc(100% - 10px);
    height: 3px;
    background: var(--tealgray600);
    content: '';
  }
}

.btncontainer1,
.btncontainer2,
.btncontainer3 {
  position: relative;
  display: flex;
  align-items: center;
  overflow: show;
  border-radius: 0.25rem;
}

.btncontainer1.show-buttons,
.btncontainer2.show-buttons,
.btncontainer3.show-buttons {
  background-color: var(--gray-200);
  margin-right: 1rem;
}

.main-border.show-buttons {
  position: relative; /* 의사 요소를 위한 상대 위치 설정 */
}

.main-border.show-buttons::after {
  content: '';
  position: absolute;
  right: 0;
  top: 15%; /* 상단 위치 조정 */
  height: 70%; /* border-right의 길이 설정 */
  width: 1px;
  background-color: var(--gray-400);
}

.main-button {
  margin-right: 0.5rem;
  z-index: 2;

  .show-buttons {
    color: #212529;
    font-weight: 400;
  }
}

.button-container {
  display: flex;
  position: relative;
}

.extra-button {
  position: relative;
  opacity: 1;
  transform: translateX(0);
}

/* 화면 크기가 sm 이하일 때 .hdd-btn과 .btn의 가로 패딩을 0으로 설정 */
@media (max-width: 1199.98px) {
  .hdd-btn,
  .dropdown-toggle {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
</style>
